<h2 mat-dialog-title class="pv-dialog-title">
    <mat-icon class="material-symbols-outlined">zoom_in</mat-icon>
    <span class="pv-dialog-title-text">Image preview</span>
    <button mat-icon-button class="pv-dialog-close" (click)="close()" matTooltip="Close" aria-label="Close preview">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content class="pv-dialog-body">
    <!-- fixed stage: the box never resizes to the image, so the dialog cannot jump between photos -->
    <div class="preview-stage">
        <pv-image-ref *ngIf="data.fileRef; else missingTpl" [fileRef]="data.fileRef" [width]="1280" mode="fit" [quality]="80"></pv-image-ref>

        <ng-template #missingTpl>
            <div class="preview-missing">
                <mat-icon>broken_image</mat-icon>
                <span>This image is unavailable.</span>
            </div>
        </ng-template>
    </div>

    <dl class="preview-context">
        <ng-container *ngFor="let item of data.context">
            <dt>{{ item.label }}</dt>
            <dd>{{ item.value }}</dd>
        </ng-container>
        <dt>Captured</dt>
        <dd [matTooltip]="data.tooltip || null">{{ data.caption }}</dd>
    </dl>
</mat-dialog-content>

<mat-dialog-actions align="end" class="pv-dialog-footer">
    <button type="button" mat-stroked-button (click)="close()">Close</button>
    <button type="button" mat-flat-button color="primary" (click)="select()">
        <mat-icon>check</mat-icon>
        Select this image
    </button>
</mat-dialog-actions>
